


import { ShipmentMaterialEditController } from './controllers/shipmentMaterialEditController';
//import '../../models/requestMaterial';
import '../../models/requestDetailEdit';

import '../materials/materialsDirective';
import '../packages/packagesDirective';
import '../assignMaterialsToPackages/assignMaterialsToPackagesDirective';
import '../attachments/attachmentsDirective';

export class ShipmentMaterialEditDirective implements angular.IDirective {
    template = require('./templates/shipmentMaterialEdit.html');
    restrict = 'E';
    controller = ShipmentMaterialEditController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit: '=',
        isLoading: '=',
        isValid :'='
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new ShipmentMaterialEditDirective();
    }
}

angular.module('deliveryCreate.app').directive('shipmentMaterialEdit', ShipmentMaterialEditDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentMaterialEdit/shipmentMaterialEditDirective.ts
 **/